var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('h1',{staticClass:"main-title"},[_vm._v(_vm._s(_vm.title)),_c('span',{staticClass:"a11y-solo-lectura"},[_vm._v(".")])]),_c('p',{staticClass:"main-description"},[_vm._v(_vm._s(_vm.description)),(_vm.description)?_c('span',{staticClass:"a11y-solo-lectura"},[_vm._v(".")]):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }